module.exports = __webpack_public_path__ + "img/banner_3.6e3e2b20.jpg";